export default "__VITE_ASSET__EFVDrcyY__"